import { computed, reactive } from "vue";

import { listAlerts } from "../api/alerts.js";

export const notifications = reactive({ loading: false, error: "", unread: 0 });
export const hasUnreadNotifications = computed(() => notifications.unread > 0);

let pending;

export async function refreshNotifications({ signal } = {}) {
  if (pending) return pending;
  notifications.loading = true;
  notifications.error = "";
  pending = listAlerts({ signal })
    .then((data) => {
      notifications.unread = Number(data.unread || 0);
      return data;
    })
    .catch((error) => {
      notifications.error = error.message || "Alerts are unavailable.";
      throw error;
    })
    .finally(() => { notifications.loading = false; pending = null; });
  return pending;
}
